import React, { useState } from "react";

const Page11 = () => {

  const [selectedIndex, setSelectedIndex] = useState(0);

  return (
    <div className="moc-page">
      {/* ESQUERDA */}
   
      <div className="moc-right" style={{ paddingTop: '100px', paddingLeft: '150px' }}>
        <p><strong>Process & Plant Safety (PPS)</strong></p>
        <p>Antes de olhar para leis e normas externas, é essencial entender como a segurança de processos e instalações é organizada.</p>
        <p>A Process & Plant Safety (PPS) reúne práticas para prevenir acidentes graves, como vazamentos, explosões e falhas de processo. Dentro desse sistema, o MOC é um dos 7 pilares da PPS e assegura que as mudanças sejam analisadas e que os riscos sejam adequadamente gerenciados, reduzindo impactos na integridade dos processos e das instalações.</p>
        <p>Esse cuidado é ainda mais crítico quando a mudança envolve materiais de alto risco (HHM – High Hazard Materials), como Cloro (Cl₂), Fósforo (P₄), Tricloreto de Fósforo (PCl₃) e Ácido Clorídrico (HCl).</p>
      </div>

      {/* DIREITA */}    
      <div className="moc-left" style={{ paddingTop: '240px', paddingRight: '100px' }}>        
        <img src="./img/module1/page12.jpg" alt="" style={{ width: '90%' }} />
      </div>


      <style>{`

        .container{
          width: 100% !important;
        }

        /* ROOT DA PÁGINA */
        .moc-page {
          display: flex;
          height: 100%;
          overflow: hidden;
        }

        /* COLUNA DIREITA */
        .moc-right {
          width: 50%;
          background: #ffffff;
          padding: 30px;
          box-sizing: border-box;

          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        /* COLUNA ESQUERDA */
        .moc-left {
          width: 50%;
          padding-top: 250px;
          background: #f1f5f9;
          color: #000000;
          padding: 40px;
          box-sizing: border-box;        }

        .moc-left p {
          white-space: pre-line;
          line-height: 1.6;
        }

        /* ================= MOBILE ================= */
        @media (max-width: 768px) {

          .moc-page {
            flex-direction: column;
            // height: auto;
          }

          .moc-left,
          .moc-right {
            width: 100%;
            padding: 20px;
          }

          .moc-left {
            padding-top: 100px !important;
          }

          .moc-right {
            padding-top: 0px !important;
          }

          .moc-right img {
            width: 100%;
            max-width: 300px;
          }

        }

      `}</style>
    </div>
  );
};

export default Page11;